<template>
  <timeline
    :data="data"
    :library="options"
  />
</template>

<script>
export default {
  name: 'ShipmentsHistory',
  data () {
    return {
      data: [
        ['1B11234', '2019-01-02T08:00:00Z', '2019-01-02T12:00:00Z'],
        ['1B11234', '2019-01-03T09:00:00Z', '2019-01-03T19:00:00Z'],
        ['1AA1234', '2019-01-02T08:00:00Z', '2019-01-02T12:00:00Z'],
        ['1AA1234', '2019-01-02T15:00:00Z', '2019-01-03T01:00:00Z'],
        ['1A31234', '2019-01-02T08:00:00Z', '2019-01-02T12:00:00Z'],
        ['1A31234', '2019-01-02T12:30:00Z', '2019-01-03T14:00:00Z']
      ],
      options: {
        timeline: { colorByRowLabel: false }
      }
    }
  }
}
</script>
